import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from "@material-ui/core/Button";

import PlannedDates from "./PlannedDates";

/**
 * Set plannedDate and deadline for a Requirement.
 * props:
 * element
 * open: show this dialog
 * onSave: callback
 * onClose: callback
 */
class SetTimeDialog extends React.Component {
  constructor(props) {
      super(props);

      this.onSave = this.onSave.bind(this);
      this.onChange = this.onChange.bind(this);

      this.state = {
          plannedStart: this.props.element.plannedStart,
          deadline: this.props.element.deadline,
      }
      console.log("SetTimeDialog:", this.state);
  }

  render() {
      let element = this.props.element;

      return (
          <Dialog open={this.props.open} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">Planned dates for {element.name}</DialogTitle>
              <DialogContent>
                  <PlannedDates element={this.props.element} onChange={this.onChange}/>
              </DialogContent>
              <DialogActions>
                  <Button onClick={this.props.onClose}>
                      Cancel
                  </Button>
                  <Button onClick={this.onSave} color="primary">
                      Save
                  </Button>
              </DialogActions>
          </Dialog>
      );
  }

  /**
    *
    * @param propertyName: plannedStart or deadline
    * @param value: a date
   */
  onChange(propertyName, value) {
      console.log("SetTimeDialog.onChange", propertyName, "=", value);
      this.setState({[propertyName]: value});
  }

  onSave() {
      console.log("SetTimeDialog.onSave state:", this.state);
      this.props.onSave(this.state);
      this.props.onClose();
  }
}

export default SetTimeDialog;
